module.exports = __webpack_public_path__ + "static/media/Classic-StylePicker.6867b38e.jpg";